import React, { useEffect, useState } from "react";
import { Box, Button, Divider, IconButton, Modal, Typography, CircularProgress, } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

import { useDeleteUsuarioPermiso } from "../../../hooks/AdministracionUsuarios/adminPermisosUsuarios/deleteUsuarioPermiso";

interface PermisoEliminar {
    id: number;
    nombre: string;
    descripcion: string;
    sufijo: string;
    estatus: number;
}

interface DeleteAdminPermisoProps {
    open: boolean;
    onClose: () => void;
    onSuccess?: () => Promise<void> | void;
    permiso: PermisoEliminar | null;
}

const DeleteAdminPermiso: React.FC<DeleteAdminPermisoProps> = ({
    open,
    onClose,
    onSuccess,
    permiso,
}) => {

    const {
        eliminarPermiso,
        loading,
    } = useDeleteUsuarioPermiso();

    const [nombre, setNombre] = useState("");
    const [descripcion, setDescripcion] = useState("");
    const [sufijo, setSufijo] = useState("");

    useEffect(() => {

        if (!open || !permiso) return;

        setNombre(permiso.nombre);
        setDescripcion(permiso.descripcion);
        setSufijo(permiso.sufijo);

    }, [open, permiso]);

    const limpiarFormulario = () => {

        setNombre("");
        setDescripcion("");
        setSufijo("");

    };

    const cerrarModal = () => {

        limpiarFormulario();

        onClose();

    };

    const eliminar = async () => {

        if (!permiso) return;

        const ok = await eliminarPermiso(permiso.id);

        if (ok) {

            await onSuccess?.();

            cerrarModal();

        }

    };

    return (

        <Modal
            open={open}
            onClose={cerrarModal}
        >

            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "90%",
                    maxWidth: 520,
                    bgcolor: "background.paper",
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 3,
                }}
            >

                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                >

                    <Typography
                        variant="h6"
                        fontWeight="bold"
                    >
                        Eliminar Permiso
                    </Typography>

                    <IconButton onClick={cerrarModal}>
                        <CloseIcon />
                    </IconButton>

                </Box>

                <Divider sx={{ mb: 3 }} />

                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    gap={2}
                >

                    <WarningAmberRoundedIcon
                        color="warning"
                        sx={{ fontSize: 70 }}
                    />

                    <Typography
                        variant="h6"
                        fontWeight={600}
                        align="center"
                    >
                        ¿Deseas eliminar este permiso?
                    </Typography>

                    <Box
                        sx={{
                            width: "100%",
                            bgcolor: "#f5f5f5",
                            borderRadius: 2,
                            p: 2,
                            mt: 1,
                        }}
                    >

                        <Typography variant="body2">
                            <strong>Nombre:</strong> {nombre}
                        </Typography>

                        <Typography
                            variant="body2"
                            mt={1}
                        >
                            <strong>Sufijo:</strong> {sufijo}
                        </Typography>

                        <Typography
                            variant="body2"
                            mt={1}
                        >
                            <strong>Descripción:</strong> {descripcion}
                        </Typography>

                    </Box>

                </Box>

                <Divider sx={{ my: 3 }} />

                <Box
                    display="flex"
                    justifyContent="flex-end"
                    gap={2}
                >

                    <Button
                        variant="contained"
                        onClick={cerrarModal}
                        sx={{
                            bgcolor: "#F70083",
                            color: "#fff",
                            fontWeight: 600,
                            textTransform: "none",
                            borderRadius: 2,
                            px: 3,
                            "&:hover": {
                                bgcolor: "#D60072",
                            },
                        }}
                    >
                        Cancelar
                    </Button>

                    <Button
                        variant="contained"
                        color="error"
                        onClick={eliminar}
                        disabled={loading}
                        sx={{
                            fontWeight: 600,
                            textTransform: "none",
                            borderRadius: 2,
                            px: 3,
                        }}
                    >
                        {loading ? (
                            <>
                                <CircularProgress
                                    size={18}
                                    color="inherit"
                                    sx={{ mr: 1 }}
                                />
                                Eliminando...
                            </>
                        ) : (
                            "Eliminar Permiso"
                        )}
                    </Button>

                </Box>

            </Box>

        </Modal>

    );

};

export default DeleteAdminPermiso;